import { render, staticRenderFns } from "./yxqnPrompt.vue?vue&type=template&id=726f83f0&scoped=true"
import script from "./yxqnPrompt.vue?vue&type=script&lang=js"
export * from "./yxqnPrompt.vue?vue&type=script&lang=js"
import style0 from "./yxqnPrompt.vue?vue&type=style&index=0&id=726f83f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f83f0",
  null
  
)

export default component.exports